import Relationship from "./relationship/Relationship";

export default function relationshipClassFactory(name: string) {
    return new Relationship(name);
}